import React, { useState } from 'react';
import { Button } from './components/ui/button';
import { FileText } from 'lucide-react';
import SolarQuoteDescription from './SolarQuoteDescription';

const DescriptionButton = ({ onDescriptionChange, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Button onClick={() => setIsOpen(true)} variant="outline" className="w-full justify-start text-left font-normal">
        <FileText className="mr-2 h-4 w-4" />
        <span>Editer</span>
      </Button>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg w-3/4 max-w-2xl">
            <h2 className="text-lg font-bold mb-2">Éditeur de description de produit</h2>
            <p className="mb-4">Utilisez cet éditeur pour créer une description détaillée du produit.</p>
            <SolarQuoteDescription onDescriptionChange={onDescriptionChange} initialDescription={description} />
            <Button onClick={() => setIsOpen(false)} className="mt-4">Valider et Fermer</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DescriptionButton;
